import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import IncomeReportsChild from "./IncomeReportsChild";

const IncomeReports = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <IncomeReportsChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default IncomeReports;
